import { cloneDeep, set } from "lodash-es"
import React, { useMemo, useState } from "react"
import CustomDialog from "components/Atoms/CustomDialog"
import StaticSelector from "components/Atoms/StaticSelector"
import { RESET_SELECTED } from "store/selector.redux"
import ButtonMutation from "components/Molecules/ButtonMutation"
import { ErrorToast, ApolloErrorToast, SuccessToast } from "utils/AppToaster"
import { useDispatch, useSelector } from "react-redux"
import { useAllDocksList } from "graphql/dms/dms.hooks.gql"
import SupervisorSuggest from "../trip-detail/SupervisorSuggest"
import { BULK_ASSIGNMENT } from "graphql/dms/dms.mutations.gql"
const AssignDockDialog = ({ isOpen, onClose, ...otherProps }) => {
  const selectedItems =
    useSelector((state: any) => state.selector?.dms?.selected) || {}
  const selectedItemsArray = Object.keys(selectedItems)

  const dispatch = useDispatch()
  const allDocks = useAllDocksList()
  const [state, setState] = useState<any>({
    dock: {},
    supervisor: { firstName: "", lastName: "", number: "" },
  })

  function handleChange(path, value) {
    const stateCopy = cloneDeep(state)
    set(stateCopy, path, value)
    setState(stateCopy)
  }

  const parsedVariables = useMemo(() => {
    return {
      tripIds: selectedItemsArray,
      dockId: state?.dock?.id,
      dockSupervisorId: state?.supervisor?.id,
    }
  }, [state, selectedItemsArray])

  return (
    <CustomDialog
      title={
        <div>
          <text>Bulk assignment</text>
        </div>
      }
      isOpen={isOpen}
      footerRightButton={
        <ButtonMutation
          icon="confirm"
          text="Assign dock"
          mutation={BULK_ASSIGNMENT}
          variables={parsedVariables}
          onError={err => {
            ApolloErrorToast(err)
          }}
          onCompleted={() => {
            SuccessToast(`Dock assignment done successfully`)
            dispatch({
              type: RESET_SELECTED,
              path: "dms",
            })
            onClose()
          }}
          validate={state => {
            if (selectedItemsArray.length === 0)
              return ErrorToast("Please select a trip first")
            if (!state?.dockId) return ErrorToast("Please select a dock")
            if (!state?.dockSupervisorId)
              return ErrorToast("Please select a dock supervisor")
            return true
          }}
        />
      }
      width="50%"
      onClose={onClose}
      {...otherProps}
    >
      <div>
        <div className="grid grid-cols-12 gap-4 mt-3">
          <div className="col-span-6">
            <StaticSelector
              path="dock"
              label="Call vehicle at dock"
              absolute
              items={allDocks || []}
              value={state.dock}
              onChange={handleChange}
            />
          </div>
          <div className="col-span-6">
            <SupervisorSuggest
              path="supervisor"
              value={state?.supervisor}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
    </CustomDialog>
  )
}

export default AssignDockDialog
